import { z } from "zod";

export const addProductSchema = z.object({
  name: z.string().min(5, "Product name"),
  price: z.string(),
  category: z.string(),
  sub_category: z.string(),
  description: z.string().min(10, "Product Description!"),
  benefits: z
    .string()
    .min(5, "Each benefit must be at least 5 characters long"),
});

export type AddProductFormData = z.infer<typeof addProductSchema>;
